module.exports = __webpack_public_path__ + "img/nritana-encyclopedia-of-nepal.68d3e9eb.jpg";